import { Map, Record } from "immutable";

import {
  CrudBuilderState,
  makeCrudBuilderInitialState
} from "seneca-common/utils/apiStates";

import { courseStatsFetchStateConfig } from "../../../consts";
import { CourseStats } from "./stats";

export { default as CourseStat } from "./stats/stat";
export type { CourseStatType, OptionalCourseStatType } from "./stats/stat";
export type { CourseStats };

export type CourseStatsStateSliceType = {
  stats: CourseStats;
  meta: CrudBuilderState;
};

const courseStatsMetaInitialState = makeCrudBuilderInitialState(
  courseStatsFetchStateConfig
);

export default class CourseStatsStateSlice extends Record({
  stats: Map(),
  meta: courseStatsMetaInitialState
}) {}
